// import isUndefined from 'lodash/isUndefined';

// import { renderCurrency } from '../../components/SystemCountry';

// import getFilterWithCol from '../../helpers/getFilterWithCol';

import { createDefaultFields } from './helpers';

import tests from '../../helpers/tests';

// import { createChangeLogSection } from '../../components/FieldChangeLog';

// import Types from '../../modules/types';

const { viewerIsNotAdmin } = tests;

export default [
  'PageSingle',
  {
    // icon: 'tool',
    path: '/settings/product-gallery-sort',
    title: 'Product Gallery Sort',
    headerTitle: 'Product Gallery Sort',
    renderHeaderTitle: () => 'Product Gallery Sort',
    hidden: false,
    activity: 'edit',
    url: '/settings/productGallerySort',
    redirect: [['redirect.unauthorized']],
    actions: [['ActionSave']],
    skip: [viewerIsNotAdmin],
    fields: createDefaultFields(),
  },
];
